import * as React from 'react';
import classnames from 'classnames';
import { DataLayer } from '@grandvisionhq/analytics';
import { RichTextArea } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { useRxGlassesConfiguratorContext } from '../../../../../context/RxGlassesConfiguratorContext.js';
import { PrescriptionInformationDrawer } from '../../../PrescriptionInformationDrawer/PrescriptionInformationDrawer.js';
import { PrescriptionInformationDrawerTrigger } from '../../../PrescriptionInformationDrawer/components/PrescriptionInformationDrawerTrigger.js';

const PupillaryDistanceDrawerLink = ({ className  })=>{
    var ref;
    const { getLabel  } = useIntl();
    const { configuratorDocument  } = useRxGlassesConfiguratorContext();
    const description = configuratorDocument === null || configuratorDocument === void 0 ? void 0 : (ref = configuratorDocument.prescriptionStep) === null || ref === void 0 ? void 0 : ref.measureDescription;
    const drawerTitle = getLabel('products.glasses.prescription.form.pdDrawerTrigger');
    const handleClick = ()=>{
        DataLayer.Events.pushDrawerEventToDataLayer({
            siteFeature: 'rxconfigurator',
            interactionType: 'how_to_measure_pupillary_distance_click'
        });
    };
    return /*#__PURE__*/ React.createElement(PrescriptionInformationDrawer, {
        trigger: /*#__PURE__*/ React.createElement(PrescriptionInformationDrawerTrigger, {
            className: classnames('pupillary-distance-drawer-link', className),
            onClick: handleClick
        }, drawerTitle),
        title: drawerTitle
    }, description && /*#__PURE__*/ React.createElement(RichTextArea, {
        content: description,
        isContained: true
    }));
};

export { PupillaryDistanceDrawerLink };
//# sourceMappingURL=PupillaryDistanceDrawerLink.js.map
